jQuery(document).ready(function ($) {
    var $parceiros = $('.home-parceiros .swiper');

    if (!$parceiros.length) return

    var mySwiper = new Swiper('.home-parceiros .swiper', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        slidesPerView: 2,
        spaceBetween: 20,
        speed: 400,
        navigation: {
            nextEl: $parceiros.parent().find(".carousel-navigation .next")[0],
            prevEl: $parceiros.parent().find(".carousel-navigation .prev")[0],
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            },
        }
    });
});